import React, { Component } from 'react'
import cs from 'classnames'
import css from './index.css'

const RatioItem = ({children,active, clickFn}) => {
  return (
    <div onClick={clickFn} className={cs(css.items)}
      data-checked={active}
    >
      {children}
    </div>
  )
}


export class RatioComp extends Component {
  constructor (props) {
    super(props);
    this.state = {
      value: 0
    }
  }
  componentWillMount() {
    const {defaultValue} = this.props;
    this.setState({
      value:defaultValue
    })
  }
  select = ({props}) => {
    const {onChange, preCheck} = this.props;
    const { label } = props;
    if(!preCheck || preCheck(label)){
      this.setState({
        value: label
      })
      onChange(label);
    }
  }
  render() {
    const {children, wrapClassName, title} = this.props;
    const { value } = this.state;
    return (
      <div>
        <div className={css.title}>{title}</div>
        <div className={wrapClassName}>
          {
            children.map((el, index)=> (
              <RatioItem
                active = {el.props.label === value}
                clickFn= {()=> this.select(el, index)}
                key = { index }
              >   
                {el}
              </RatioItem>
            ))
          }
        </div>
      </div>
      
    )
  }
}

export default RatioComp



// WEBPACK FOOTER //
// ./src/components/common/Ratio/index.js